function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../../messages';
import Field from './Field';
import Logo from './Logo';
import OrganizationIdentifier from './OrganizationIdentifier';
const BasicInformation = ({ formValues })=>/*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("h5", {
                className: "text--h5",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.organizationBasicInfo))
            }),
            /*#__PURE__*/ _jsx(Field, {
                id: "name",
                formValues: formValues
            }),
            /*#__PURE__*/ _jsx(Logo, {
                formValues: formValues
            }),
            /*#__PURE__*/ _jsx(Field, {
                id: "country",
                formValues: formValues
            }),
            /*#__PURE__*/ _jsx(Field, {
                id: "language",
                formValues: formValues
            }),
            /*#__PURE__*/ _jsx(OrganizationIdentifier, {
                formValues: formValues
            })
        ]
    });
export default BasicInformation;
